import ARGBToRGBA from 'searchband-frontend-commons/util/color/argb-to-rgba';

/**
 * Парсера цвета
 * @param  {String} color
 * @param  {String} defaultColor
 * @return {String}
 */
export default (function () {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var defaultColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return ARGBToRGBA(String(color)) || defaultColor;
});